import {Map} from 'immutable';
import {CARREGAR_MAPA_POLYS} from '../constants/constants'

export default (mapa = Map(), action) =>{
    switch(action.type){
        case CARREGAR_MAPA_POLYS:
            return Map(action.mapa)
    }
    return mapa;
}


// WEBPACK FOOTER //
// ./src/reducers/mapa.js